/* eslint-disable */
import runFirst from './run_first'
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAWN from "vue-awesome-notifications"
import { bi10BooleanUtils } from "./watchdog_includes/base_i10_UI_mixins"

let options = {maxNotifications:1 ,position: 'top-right'}
Vue.use(VueAWN, options)
Vue.mixin(bi10BooleanUtils);

Vue.config.productionTip = false

window.G_vue_instance = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data: {
    userInfo: {
      firstName: 'DGnet Watchdog Guest',
      lastName: '',
      contactEmail: '',
      uid: 0,
      authenticated: false,

      isGuest: window.location.search.includes('token=') ? true : false
    },
    webGui: {
      watchdogDbConnected: false,
    },
    selectedSubModals: []
  }
})

window.G_firebase_auth.bi5InitFirebase()


// WEBPACK FOOTER //
// ./src/main.js